import type { SVGProps } from "react";

export function IconVideoSubtitles(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="14"
      viewBox="0 0 20 14"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video subtitles</title>
      <rect
        height="12.5"
        rx="1.5"
        stroke="white"
        strokeWidth="1.5"
        width="18.5"
        x="0.75"
        y="0.75"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
        x1="4"
        x2="10"
        y1="5"
        y2="5"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
        x1="12"
        x2="16"
        y1="5"
        y2="5"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
        x1="4"
        x2="8"
        y1="9"
        y2="9"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
        x1="10"
        x2="16"
        y1="9"
        y2="9"
      />
    </svg>
  );
}
